import { tapi as axios } from 'src/api';
import type { BaseSchema } from 'src/routes/widgets/TradeProWidget/state/types';
import { container } from 'src/StaticContainer';

const logger = container.get('Logger');

export async function getExecutorsJsonSchema({ account }: { account: string }): Promise<BaseSchema> {
    return axios
        .get<BaseSchema>('/orders/schema', {
            params: {
                account,
            },
        })
        .then((response) => response.data)
        .catch((e) => {
            logger.error('Error fetching JSON Schema for account', { error: e, account });
            throw e;
        });
}
